export class SamlIdentityProviderConfigsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "samlIdentityProviders",
            "baseName": "samlIdentityProviders",
            "type": "Array<SamlIdentityProvider>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SamlIdentityProviderConfigsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
